export const fields = {
  file: {
    extension:
      ".pdf,.jpg,.jpeg,.png,.bmp,.docx,.xlsx,.xdw,.heic,.webp,.jfif,.heif",
    maxFileSize: {
      value_bytes: 10485760, //10メガバイト
    },
  },
} as const;

export default fields;
